import { Outlet, useNavigate } from "react-router-dom";
import SettingsSideBar from "../../components/Settings/SettingsSidebar";
import { useEffect } from "react";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";

const UserSettings = () => {
  const navigate = useNavigate();
  const { SelectedOrg } = useStateGetter();

  return (
    <div className="h-full w-screen flex mt-4 overflow-y-hidden">
      <div className="w-[30vw] px-14 h-full  overflow-y-hidden">
        <SettingsSideBar isusersettings />
      </div>

      <div className=" w-[70vw] flex justify-start items-start overflow-y-scroll">
        <Outlet />
      </div>
    </div>
  );
};

export { UserSettings };
